export const COMMENTS_OPEN_EVENT_NAME = 'comments:open';
export const COMMENTS_CLOSED_EVENT_NAME = 'comments:closed';
export const COMMENTS_READ_EVENT_NAME = 'comments:read';
export const DEFAULT_CLOSED_INTERVAL_MS = 5_000;
